import { Keuzehulp } from '../keuzehulpen'

const verzakking: Keuzehulp = {
  title: 'Verzakking',
  basePath: '/verzakking',
  documentTitle: 'Verzakking',
  routes: [
    {
      path: '',
      routeId: 'P6-001',
      nextRouteId: 'P6-002',
      type: 'intro',
      title: 'Voordat u begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/wat-is-er-mogelijk-bij-verzakking',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die u nodig heeft om de keuzehulp in te vullen',
        },
        {
          title: '10 tot 15 minuten',
          description: 'Zo lang doen de meeste mensen over deze keuzehulp',
        },
        {
          title: 'Zoek een rustig plekje',
          description: 'Zodat u zich zonder afleiding kunt concentreren',
        },
        {
          title: 'Download uw gegevens',
          description: 'Aan het einde kunt u uw antwoorden bekijken en printen',
        },
      ],
    },
    {
      path: '/stap-1',
      routeId: 'P6-002',
      nextRouteId: 'P6-003',
      type: 'chapter',
      title: 'Wat is een verzakking?',
      subtitle: 'Stap 1',
      description: 'Bij een verzakking zitten 1 of meer organen niet meer goed op hun plaats.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/vzk-stap-1.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/wat-is-een-verzakking',
      routeId: 'P6-003',
      nextRouteId: 'P6-004',
      type: 'explanation',
      title: 'Wat is een verzakking?',
      subtitle: 'Stap 1',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom: 0">Bij een verzakking zitten 1 of meer van de volgende organen niet meer goed op hun plaats:</p>
          <ul>
            <li>de baarmoeder</li>
            <li>de top van de vagina (als uw baarmoeder is weggehaald)</li>
            <li>de blaas</li>
            <li>de darm</li>
          </ul>
          <p>Spieren en banden houden deze organen op hun plaats. Banden zijn een soort elastiekjes.<br>
          De spieren en banden kunnen zwakker worden of beschadigd raken.
          <br>Dan kunnen de organen zakken, tot in de vagina, of naar buiten.</p>
          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">U heeft meer kans op een verzakking door 1 of meer van deze dingen:</h2>
          <ul style="margin-bottom: 0">
            <li>een bevalling</li>
            <li>overgewicht</li>
            <li>veel hoesten (bijvoorbeeld door COPD of roken)</li>
            <li>vaak hard persen bij het poepen</li>
            <li>als uw moeder of zus ook een verzakking heeft (gehad)</li>
            <li>ouder worden.</li>
          </ul>
          <p style="margin-top: 0">Deze dingen kunnen uw verzakkings-klachten ook erger maken.</p>
          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is zo bij alle soorten verzakkingen:</h2>
          <ul>
            <li>Niet iedereen met een verzakking heeft klachten.</li>
            <li>Als u wel klachten heeft, worden ze vaak erger tijdens de dag.</li>
            <li>Klachten kunnen ook erger worden door zwaar tillen of lang lopen.</li>
            <li>Er is dan veel druk op de bekkenbodem.</li>
            <li>Na platliggen worden de klachten meestal minder.</li>
            <li>De verzakking kan geen kwaad.</li>
          </ul>
        </div>
        `,
      button: 'Volgende',
    },
    {
      path: '/stap-1/vraag-1',
      routeId: 'P6-004',
      nextRouteId: 'P6-005',
      type: 'question',
      hideFromOverview: true,
      title: 'Waar wilt u meer over weten?',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Verzakking van de baarmoeder of vaginatop',
              showChapter: '1.3',
            },
            {
              title: 'Verzakking van de blaas',
              showChapter: '1.4',
            },
            {
              title: 'Verzakking van de darm',
              showChapter: '1.5',
            },
            {
              title: 'Geen van de bovenstaande',
              skipAll: true,
            },
          ],
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-1/verzakking-van-de-baarmoeder-of-vaginatop',
      routeIndex: '1.3',
      routeId: 'P6-005',
      nextRouteId: 'P6-006',
      type: 'explanation',
      title: 'Verzakking van de baarmoeder of vaginatop',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <div class="mb-5">
            <h2 style="font-size: 18px; line-height: 1.6;">Wat is een verzakking van de baarmoeder of vaginatop?</h2>
            <p>De baarmoeder wordt niet meer goed op z’n plek gehouden. <br>Hierdoor zakt de baarmoeder in de vagina. <br>Soms zakt de baarmoeder verder, tot buiten de vagina.</p>
            <div class="img-wrapper-lg">
              <img src=${process.env.PUBLIC_URL}/img/vzk-baarmoeder.png alt="" />
            </div>
            <div class="img-wrapper-lg">
              <img src=${process.env.PUBLIC_URL}/img/vzk-prolaps-baarmoeder.png alt="" />
            </div>
            <p style="margin-top: 40px">Is uw baarmoeder eerder weggehaald? Dan kan de top van de vagina verzakken.</p>
            <div class="img-wrapper-lg">
              <img src=${process.env.PUBLIC_URL}/img/vzk-vaginatop.png alt="" />
            </div>
            <div class="img-wrapper-lg">
              <img src=${process.env.PUBLIC_URL}/img/vzk-prolaps-vaginatop.png alt="" />
            </div>
          </div>
          <h2 style="font-size: 18px; line-height: 1.6;">Wat merkt u bij een verzakking van de baarmoeder of vaginatop?</h2>
          <p style="margin-bottom: 0">U kunt 1 of meer van de volgende klachten hebben:</p>
          <ul>
            <li>U heeft een zwaar gevoel in de vagina, alsof er iets naar buiten komt. Sommige vrouwen hebben het gevoel dat er een bal tussen hun benen zit. Of het gevoel dat ze ergens op zitten.</li>
            <li>U heeft een zeurend gevoel of pijn in uw onderbuik, benen of liezen. Ook kunt u pijn in de rug hebben.</li>
            <li>U kunt niet goed zitten, fietsen of wandelen.</li>
            <li>U ziet of voelt de baarmoedermond bij de ingang van uw vagina. U kunt het gevoel hebben dat er iets in de vagina zit. Of dat er juist te veel ruimte is.</li>
            <li>U kunt uw plas of poep niet ophouden. Of u heeft juist moeite met plassen of poepen.</li>
            <li>Vrijen kan anders voelen. </li>
          </ul>
          <p>Soms zijn ook de blaas en/of de darm verzakt. Dan kunt u ook nog andere klachten hebben.</p>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-1/verzakking-van-de-blaas',
      routeIndex: '1.4',
      routeId: 'P6-006',
      nextRouteId: 'P6-007',
      type: 'explanation',
      title: 'Verzakking van de blaas',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <div class="mb-5">
            <h2 style="font-size: 18px; line-height: 1.6;">Wat is een verzakking van de blaas?</h2>
            <p>De blaas wordt niet meer goed op z’n plek gehouden. <br>Hierdoor zakt de onderkant van de blaas in de vagina. <br>De blaas duwt tegen de wand van de vagina. <br>De wand aan de voorkant van uw vagina (de kant van uw buik) komt naar buiten.</p>
            <div class="img-wrapper-lg">
              <img src=${process.env.PUBLIC_URL}/img/vzk-blaas.png alt="" />
            </div>
            <div class="img-wrapper-lg">
              <img src=${process.env.PUBLIC_URL}/img/vzk-prolaps-blaas.png alt="" />
            </div>
          </div>
          <h2 style="font-size: 18px; line-height: 1.6;">Wat merkt u bij een verzakking van de blaas?</h2>
          <p style="margin-bottom: 0">U kunt 1 of meer van de volgende klachten hebben:</p>
          <ul>
            <li>U heeft een zwaar gevoel in de vagina, alsof er iets naar buiten komt.</li>
            <li>U moet vaak plassen.</li>
            <li>U kunt uw blaas niet goed leegplassen.</li>
            <li>U plast met een slappere of sproeiende straal.</li>
            <li>U kunt vaak blaasontsteking hebben. Dat komt doordat u uw blaas niet goed leeg plast.</li>
            <li>U verliest urine.</li>
            <li>Vrijen kan anders voelen.</li>
          </ul>
          <p>Soms zijn ook de baarmoeder of vaginatop en/of de darm verzakt. Dan kunt u ook nog andere klachten hebben.</p>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-1/verzakking-van-de-darm',
      routeIndex: '1.5',
      routeId: 'P6-007',
      nextRouteId: 'P6-008',
      type: 'explanation',
      title: 'Verzakking van de darm',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <div class="mb-5">
            <h2 style="font-size: 18px; line-height: 1.6;">Wat is een verzakking van de darm?</h2>
            <p>De darm wordt niet meer goed op z’n plek gehouden. <br>Hierdoor zakt het laatste stukje van de darm in de vagina. <br>De darm duwt tegen de wand van de vagina. <br>De achterkant van de wand van uw vagina (aan de kant van uw rug) komt naar buiten.</p>
            <div class="img-wrapper-lg">
              <img src=${process.env.PUBLIC_URL}/img/vzk-darm.png alt="" />
            </div>
            <div class="img-wrapper-lg">
              <img src=${process.env.PUBLIC_URL}/img/vzk-prolaps-darm.png alt="" />
            </div>
          </div>
          <h2 style="font-size: 18px; line-height: 1.6;">Wat merkt u bij een verzakking van de darm? </h2>
          <p style="margin-bottom: 0">U kunt 1 of meer van de volgende klachten hebben:</p>
          <ul>
            <li>U heeft een zwaar gevoel in de vagina, alsof er iets naar buiten komt.</li>
            <li>U voelt dat uw darm na het poepen niet leeg is. Misschien moet u kort na elkaar meerdere keren terug naar de wc om te poepen. </li>
            <li>U heeft last van verstopping of u kunt de poep juist niet ophouden. </li>
            <li>Vrijen kan anders voelen.</li>
            <li>U voelt minder goed het verschil tussen een windje en ontlasting.</li>
          </ul>
          <p>Soms zijn ook de baarmoeder of vaginatop en/of de blaas verzakt. Dan kunt u ook nog andere klachten hebben.</p>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2',
      routeId: 'P6-008',
      nextRouteId: 'P6-009',
      type: 'chapter',
      title: 'Wat zijn de mogelijkheden?',
      subtitle: 'Stap 2',
      description: 'Lees hier wat u kunt doen tegen uw verzakking.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/vzk-stap-2.jpg`,
        alt: 'Stap - 2',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/wat-zijn-de-mogelijkheden',
      routeId: 'P6-009',
      nextRouteId: 'P6-010',
      type: 'explanation',
      title: 'Wat zijn de mogelijkheden?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <ul>
            <li>niets doen</li>
            <li>gezonder leven en adviezen opvolgen: uw leefstijl aanpassen</li>
            <li>bekkenbodem-oefeningen (zelf of met hulp van een bekken-fysiotherapeut)</li>
            <li>een pessarium</li>
            <li>een operatie</li>

            <p class="mb-3">Uw leefstijl aanpassen blijft altijd belangrijk.<br />
            Ook als u kiest voor bekkenbodem-oefeningen, een pessarium of een operatie.</p>
          </ul>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2/niets-doen',
      routeId: 'P6-010',
      nextRouteId: 'P6-011',
      type: 'explanation',
      title: 'Niets doen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p class="mb-3">Als u weinig klachten heeft, hoeft er niets te gebeuren. <br />
          Een verzakking kan geen kwaad.</p>

          <h2>Wat kan ik verwachten als ik niets doe?</h2>
          <p class="mb-3">Uw verzakking en uw klachten kunnen lang hetzelfde blijven.<br />
          De verzakking kan ook erger worden, waardoor u misschien meer klachten krijgt.<br />
          Of dat bij u gebeurt en hoe snel dat gebeurt, kunnen we niet voorspellen</p>

          <h2>Wat zijn de voordelen van niets doen?</h2>
          <ul class="mb-3">
            <li>U hoeft niets te doen. U hoeft nergens aan te denken.</li>
            <li>U hoeft niet naar het ziekenhuis.</li>
            <li>Er is geen kans dat er iets misgaat bij een behandeling.</li>
            <li>U kunt altijd nog kiezen voor een behandeling. U bent dan niet ‘te laat’.</li>
            <li>Het maakt niet uit of u nu of later kiest voor een behandeling.</li>
            <li>De kans dat een behandeling helpt, blijft hetzelfde.</li>
          </ul>

          <h2>Wat zijn de nadelen van niets doen?</h2>
          <ul class="mb-3">
            <li>Uw verzakking en klachten blijven.</li>
            <li>U weet niet of uw verzakking en klachten hetzelfde zullen blijven of erger worden.</li>
          </ul>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2/leefstijl-aanpassen',
      routeId: 'P6-011',
      nextRouteId: 'P6-012',
      type: 'explanation',
      title: 'Leefstijl aanpassen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          Minder druk op uw bekkenbodem kan de verzakking en uw klachten minder maken.<br />
          Zo kunt u de druk op uw bekkenbodem minder maken:
          <ul class="mb-3">
            <li>Val af als u te zwaar bent.</li>
            <li>Stop met roken. U hoest dan mogelijk minder, waardoor er minder druk op de bekkenbodem komt.</li>
            <li>Til geen zware dingen. Til bijvoorbeeld liever de boodschappen in 2 keer in de auto.</li>
            <li>Zorg dat u niet hoeft te persen bij het poepen. Dat doet u door de poep zacht te houden. Zo houdt u uw poep zacht:</li>
            <ul style="margin-left: 25px">
              <li>Drink minstens 1,5 tot 2 liter per dag.</li>
              <li>Eet veel vezels (25 tot 30 gram). Vezels zitten bijvoorbeeld in fruit, volkorenbrood en groente.</li>
              <li>Beweeg minimaal 2,5 uur per week actief.</li>
              <li>Soms helpt dit niet genoeg. Gebruik dan medicijnen om de poep zacht te houden.</li>
            </ul>
          </ul>

          <h2>Wat kan ik verwachten als ik mijn leefstijl aanpas?</h2>
          <p class="mb-3">Als u een kleine verzakking heeft, kunnen de adviezen helpen om de verzakking en uw klachten minder erg te maken.<br />
          Bij een ernstige verzakking helpt het niet genoeg om alleen uw leefstijl aan te passen.</p>

          <h2>Wat zijn de voordelen als ik mijn leefstijl aanpas?</h2>
          <ul class="mb-3">
            <li>Er is een kans dat uw verzakking en klachten minder worden.</li>
            <li>U kunt de adviezen zelf uitvoeren.</li>
            <li>U hoeft niet naar het ziekenhuis.</li>
            <li>Er kan niks misgaan.</li>
            <li>Afvallen als u te zwaar bent, stoppen met roken en meer bewegen, is heel goed voor uw gezondheid. U maakt de kans op veel andere klachten en ziektes kleiner.</li>
            <li>U kunt altijd nog kiezen voor een andere behandeling. U bent dan niet ‘te laat’.</li>
            <li>Het maakt niet uit of u nu of later kiest voor een andere behandeling. De kans dat een behandeling helpt, blijft hetzelfde.</li>
          </ul>

          <h2>Wat zijn de nadelen als ik mijn leefstijl aanpas?</h2>
          <ul class="mb-3">
            <li>Uw verzakking blijft.</li>
            <li>Het kan moeilijk zijn om uw manier van leven aan te passen.</li>
            <li>Als u stopt met de adviezen, kunnen uw klachten weer terugkomen.</li>
            <li>Bij een ernstige verzakking helpt het niet genoeg om alleen uw leefstijl aan te passen.</li>
          </ul>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2/bekkenbodem-oefeningen',
      routeId: 'P6-012',
      nextRouteId: 'P6-013',
      type: 'explanation',
      title: 'Bekkenbodem-oefeningen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>U doet elke dag oefeningen om de spieren in uw bekkenbodem sterker te maken.<br />
          En u leert ook hoe u deze spieren kunt ontspannen.</p>
          <p>Kies 2 vaste momenten waarop u de oefeningen doet. Bijvoorbeeld tijdens het tandenpoetsen. Doe dit elke dag. Daarnaast doet u de oefeningen ook op andere momenten op een dag. Bijvoorbeeld als u in de rij staat voor de kassa of tijdens het koken.</p>
          <p>Soms lukt het niet om de oefeningen zelf te leren. U kunt ook twijfelen of u de oefeningen wel goed doet. Of u merkt na een aantal weken helemaal geen effect.  Dan kunt u naar een bekken-fysiotherapeut om de oefeningen te leren. De bekken-fysiotherapeut kan u ook helpen om de oefeningen vol te houden, of kijken of u ze nog steeds goed doet. Na een tijdje hoeft u niet meer te komen.</p>
          <p class="mb-3">Misschien wordt de behandeling door een bekken-fysiotherapeut niet vergoed door uw zorgverzekeraar.</p>

          <h2>Wat kan ik verwachten van bekkenbodem-oefeningen?</h2>
          <p>Bij een kleine verzakking kunnen bekkenbodem-oefeningen helpen om de verzakking en uw klachten minder erg te maken. Bij een ernstige verzakking helpt het niet genoeg om alleen bekkenbodem-oefeningen te doen.</p>
          <p class="mb-3">Het is belangrijk dat u de oefeningen uw hele leven blijft doen. Na een tijdje hoeft u de oefeningen minder vaak te doen. Als u merkt dat de klachten terugkomen weet u dat u de oefeningen weer vaker moet doen. Als u stopt met de oefeningen, komen uw klachten misschien terug.</p>

          <h2>Wat zijn de voordelen van bekkenbodem-oefeningen?</h2>
          <ul class="mb-3">
            <li>Er is een kans dat uw verzakking en klachten minder worden.</li>
            <li>U hoeft niet naar het ziekenhuis.</li>
            <li>Er kan niks misgaan.</li>
            <li>U kunt de oefeningen zelf leren. U kunt ook hulp krijgen van een bekken-fysiotherapeut.</li>
            <li>U kunt altijd nog kiezen voor een andere behandeling. U bent dan niet ‘te laat’.</li>
            <li>Het maakt niet uit of u nu of later kiest voor een andere behandeling. De kans dat een behandeling helpt, blijft hetzelfde.</li>
            <li>Een bekken-fysiotherapeut kan u ook leefstijladviezen geven.</li>
            <li>Heeft u ook last van urineverlies? Bekkenbodem-oefeningen kunnen dan ook helpen.</li>
          </ul>

          <h2>Wat zijn de nadelen van bekkenbodem-oefeningen?</h2>
          <ul class="mb-3">
            <li>Uw verzakking blijft.</li>
            <li>Oefeningen kunnen soms lastig zijn om te leren. Als het niet lukt om de oefeningen te leren, kunt u naar de bekken-fysiotherapeut.</li>
            <li>U moet de oefeningen in het begin elke dag doen. Later hoeft u de oefeningen minder vaak te doen, maar wel tenminste meerdere keren per week. De oefeningen worden een onderdeel van uw leven.</li>
            <li>Bij een ernstige verzakking helpt het niet genoeg om alleen bekkenbodem-oefeningen te doen.</li>
          <ul>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2/pessarium',
      routeId: 'P6-013',
      nextRouteId: 'P6-014',
      type: 'explanation',
      title: 'Pessarium',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Een pessarium zorgt ervoor dat de organen beter op hun plek blijven.<br />
          Hierdoor worden uw klachten minder of verdwijnen ze helemaal.</p>

          <p>Een pessarium is niet voor iedereen geschikt.<br />
          Dit hangt bijvoorbeeld af van de stevigheid van uw bekkenbodem.<br />
          Uw arts bespreekt dit met u.</p>

          <p>Een pessarium is meestal gemaakt van kunststof of soepel rubber.<br />
          Meestal krijgt u een pessarium in de vorm van een ring.<br />
          Daarom wordt een pessarium soms ook wel een ring genoemd.<br />
          Er zijn ook pessaria in andere vormen, bijvoorbeeld een kubus.<br />
          Pessaria zijn er in verschillende maten.</p>

          <div class="img-wrapper" class="mb-3">
            <img src="${process.env.PUBLIC_URL}/img/vzk-afbeelding-pessaria-3.png" alt="vzk prolaps 5 pessarium 2" />
          </div>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is hoe u het pessarium krijgt:</h2>
          <ul>
            <li>De arts onderzoekt de binnenkant van uw vagina.</li>
            <li>De arts voelt met de vingers welke maat pessarium u nodig heeft.</li>
            <li>De arts bespreekt met u welk pessarium het beste bij u past.</li>
            <li>De arts knijpt het pessarium samen en brengt het in als een tampon.</li>
            <li>Daarna duwt de arts het naar de goede plaats.</li>
          </ul>

          <p>Zit het pessarium goed? Dan voelt u het pessarium niet meer zitten.<br/>
          Doet het pessarium pijn of valt het pessarium eruit als u perst? Dan kan het zijn dat de maat of de vorm niet helemaal goed is.<br/>
          Bespreek dit met uw arts. Veel vrouwen moeten een paar keer een ander pessarium proberen voordat zij de juiste gevonden hebben.<br/>
          Het is dus heel normaal dat het pessarium niet in 1 keer past.</p>

          <p>Soms lukt het niet om met de huisarts het juiste pessarium te vinden.<br/>
          Dan kunt u naar de gynaecoloog.<br/>
          De gynaecoloog heeft meestal meer soorten die u kunt proberen.</p>

          <div class="img-wrapper" class="mb-2">
            <img src="${process.env.PUBLIC_URL}/img/vzk-prolaps-5-pessarium-2.png" alt="vzk prolaps 5 pessarium 2" />
          </div>

          <p>U kunt het pessarium meestal zelf uit uw vagina halen.<br/>
          U wast het pessarium daarna onder de kraan en brengt het weer in.
          In het begin zal dit misschien vreemd zijn, maar het wordt snel makkelijker.<br/>
          Lukt het niet om zelf te doen? Of wilt u het liever niet zelf doen?<br/>
          Dan kan uw huisarts of gynaecoloog u helpen.</p>

          <p>Het pessarium moet minimaal elke 3 tot 6 maanden schoongemaakt worden.<br/>
          Hoe vaak precies, verschilt per persoon. Uw arts bespreekt dit met u.<br/>
          U kunt er ook voor kiezen om het pessarium er vaker uit te halen, bijvoorbeeld elke avond.<br/>
          U kunt het pessarium ook alleen gebruiken tijdens het sporten.<br/>
          Dit bepaalt u zelf.</p>

          <p class="mb-3">U en uw partner hebben meestal geen last van het pessarium bij het vrijen.<br/>
          U kunt het pessarium er ook uithalen voor het vrijen.</p>

        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2/pessarium-2',
      routeId: 'P6-014',
      nextRouteId: 'P6-015',
      type: 'explanation',
      title: 'Pessarium',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2>Wat kan ik verwachten van een pessarium?</h2>
          <div class="img-wrapper" class="mb-3">
            <img src="${process.env.PUBLIC_URL}/img/vzk-stats-1.png" alt="statistieken" />
          </div>

          <h2>Wat zijn de voordelen van een pessarium?</h2>
          <ul class="mb-3">
            <li>U bent meteen van uw klachten af.</li>
            <li>U hoeft niet naar het ziekenhuis als uw huisarts het juiste pessarium voor u heeft.</li>
            <li>Als u de juiste maat pessarium heeft en geen klachten, dan hoeft u niet meer naar een arts.</li>
            <li>U kunt het pessarium zelf schoonmaken.</li>
            <li>Kiest u ook voor bekkenbodem-oefeningen? Dan zijn de oefeningen die u krijgt vaak beter uit te voeren als u ook een pessarium draagt.</li>
            <li>Heeft u ook last van urineverlies? Een pessarium kan dan ook helpen.</li>
            <li>Bijna iedereen kan een pessarium krijgen.</li>
          </ul>

          <h2>Wat zijn de nadelen van  een pessarium?</h2>
          <ul class="mb-3">
            <li>Misschien is de maat van het pessarium niet in 1 keer goed. U moet dan een paar keer een ander pessarium proberen. U komt hiervoor steeds terug bij uw huisarts en/of gynaecoloog.</li>
            <li>Het pessarium kan eruit vallen. U kunt het pessarium dan zelf terugplaatsen. De huisarts of gynaecoloog kan dit ook doen. Dit hoeft niet meteen. Het is niet erg als het pessarium er even uit is.</li>
            <li>Het pessarium moet minimaal elke 3 tot 6 maanden schoongemaakt worden. U kunt dit zelf doen. Als u dit niet zelf kunt of wilt, moet u hiervoor naar de huisarts of gynaecoloog.</li>
            <li>U heeft waarschijnlijk meer afscheiding door het pessarium. Dit kan geen kwaad.</li>
            <li>U heeft een kleine kans op wondjes en drukplekken in de vagina als u het pessarium lang achter elkaar draagt. Dit merkt u door meer afscheiding, pijn en soms bloedverlies. Ga dan naar de huisarts of gynaecoloog.</li>
            <ul style="margin-left: 25px">
              <li>Het pessarium moet er dan tijdelijk uit. De vagina kan dan weer herstellen.</li>
              <li>Soms krijgt u van de arts een crème of zetpil met hormonen. Deze doet u in uw vagina. De hormonen zorgen ervoor dat de wand van de vagina sterker wordt. Dit voorkomt of geneest de wondjes en drukplekken.</li>
              <li>U heeft misschien een ander pessarium nodig.</li>
            </ul>
            <li>Heel soms kunt u door het pessarium moeilijker plassen of poepen. Dit kan komen door een verkeerde maat pessarium. Overleg dan met uw huisarts of gynaecoloog.</li>
            <li>Sommige vrouwen krijgen door een pessarium (meer) urineverlies. Bijvoorbeeld als u hoest, lacht of niest.</li>
            <li>Niet elke huisarts kan een pessarium bij u aanmeten. Ook kan het zijn dat de huisarts niet het juiste pessarium op voorraad heeft. Hij/zij stuurt u dan door naar een andere huisarts, of naar de gynaecoloog.</li>
          </ul>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2/operatie',
      routeId: 'P6-015',
      nextRouteId: 'P6-016',
      type: 'explanation',
      title: 'Operatie',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p class="mb-2">Er zijn verschillende soorten operaties die helpen tegen een verzakking.<br />
          De gynaecoloog bespreekt met u welke operatie in uw situatie het meest geschikt is.<br />
          Dit hangt bijvoorbeeld af van welk orgaan verzakt is.<br />
          Zijn er bij u meer organen verzakt? Dan kan de gynaecoloog u opereren in 1 operatie.<br />
          De gynaecoloog bespreekt dit met u.</p>

          <h2>Hoe goed helpt een operatie?</h2>
          <p>Na de operatie is de verzakking weg. Nadat u hersteld bent van de operatie zijn de klachten weg.<br />
          Bij ongeveer 25 van de 100 vrouwen komt de verzakking terug na een operatie.<br />
          Het verschilt per persoon wanneer de verzakking terugkomt.<br />
          U heeft hier niet altijd klachten van.<br />
          Als u wel klachten heeft kunt u kiezen voor een nieuwe behandeling.</p>

          <div class="img-wrapper mb-3">
            <img src="${process.env.PUBLIC_URL}/img/vzk-stats-2.png" alt="statistieken" />
          </div>

          <h2>Wat kan er misgaan bij een operatie?</h2>
          <h3 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Tijdens of snel na de operatie krijgen sommige vrouwen deze klachten:</h3>
          <ul class="mb-3">
            <li>Blaasontsteking.</li>
            <li>Bloeding.</li>
            <li>Ontsteking van de wond.</li>
            <li>Bloedprop in de bloedvaten in de benen (trombose).</li>
            <li>Schade aan blaas of darm.</li>
            <li>Moeite met uitplassen de dagen na de operatie. Dit is bijna altijd tijdelijk.</li>
          </ul>

          <h3 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Langer na de operatie komen deze klachten voor:</h3>
          <ul>
            <li>Pijn bij het vrijen (na de 6 weken dat er niets in de vagina mag komen).</li>
            <li>Urineverlies. Dit kan weer overgaan.</li>
          </ul>

          <p class="mb-3">Als u kiest voor een operatie, bespreekt uw arts de bijwerkingen per soort operatie met u.</p>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2/operatie-2',
      routeId: 'P6-016',
      nextRouteId: 'P6-017',
      type: 'explanation',
      title: 'Operatie',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2 >Wat kan ik verwachten van de operatie?</h2>
          <p>Voor de operatie wordt u in een diepe slaap gebracht of is een deel van uw lichaam verdoofd.</p>

          <h3 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Na de operatie</h3>
          <p style="margin-top: 0;">Hoe het na de operatie gaat, is na alle soorten operaties ongeveer hetzelfde:</p>
          <ul>
            <li>U heeft na de operatie:</li>
            <ul style="margin-left: 25px">
              <li>een katheter. Dit is een slangetje dat via de plasbuis naar de blaas loopt.  De urine loopt dan door de katheter in een zak.  U hoeft dus niet naar de wc te gaan om te plassen. Meestal wordt de katheter de dag na de operatie weggehaald.</li>
              <li> een soort grote tampon in uw vagina. Meestal wordt de tampon de dag na de operatie weggehaald.</li>
            </ul>
            <li>Na de operatie bent u 1 tot 2 dagen in het ziekenhuis.</li>
            <li>Daarna gaat u naar huis. U hoeft niet in bed te blijven. U kunt lichte activiteiten doen. Bijvoorbeeld kleine stukjes wandelen. De meeste vrouwen hebben weinig pijn. U mag zelf autorijden als u geen last meer heeft van de narcose of pijn. Na 3 weken mag u weer fietsen.</li>
          </ul>

          <ul class="mb-3">
            <li>Adviezen voor de eerste 6 weken na de operatie:</li>
            <ul style="margin-left: 25px">
              <li>Er mag niks in uw vagina komen. U mag daarom:</li>
              <ul style="margin-left: 25px">
                <li>geen seks hebben waarbij er iets in uw vagina komt</li>
                <li>geen tampons gebruiken</li>
                <li>niet in bad, naar de sauna of zwemmen</li>
                <li>niet zwaar tillen</li>
                <li>niet springen</li>
                <li>geen buikspieroefeningen doen</li>
              </ul>
            </ul>
            <li>De meeste vrouwen kunnen na 6 weken weer werken. Als u voelt dat iets te zwaar voor u is, wacht er dan nog even mee.</li>
            <li>U heeft afscheiding uit de vagina. Dit kan tot 6 weken na de operatie duren. De eerste week kan er ook bloed bij zitten. Ruikt de afscheiding anders dan normaal of heeft u koorts? Neem dan contact op met uw arts.</li>
            <li>Poep moet makkelijk komen. Eet gezond, met genoeg vezels (25 tot 30 gram). Drink 1,5 tot 2 liter. Soms zijn er (tijdelijk) medicijnen nodig om de poep zacht te houden.</li>
          </ul>

          <h2>Wat zijn de voordelen van een operatie?</h2>
          <ul class="mb-3">
            <li>De verzakking is weg.</li>
            <li>Uw klachten zijn weg (als u een paar weken na de operatie weer beter bent).</li>
            <li>U krijgt nog een controle na de operatie. Daarna hoeft u niet meer naar uw huisarts of gynaecoloog.</li>
          </ul>

          <h2>Wat zijn de nadelen van een operatie?</h2>
          <ul class="mb-3">
            <li>U wordt 1 tot 2 dagen in het ziekenhuis opgenomen.</li>
            <li>U heeft kans dat er iets misgaat bij de operatie.</li>
            <li>U moet herstellen na de operatie. Misschien heeft u pijn na de operatie.</li>
            <li>U mag 6 weken niet zwaar tillen, en geen oefeningen doen. Er mag niks in de vagina komen.</li>
            <li>De operatie kan niet ongedaan gemaakt worden.</li>
            <li>Er is een kans dat de verzakking terugkomt.</li>
          </ul>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-3',
      routeId: 'P6-017',
      nextRouteId: 'P6-018',
      type: 'chapter',
      title: 'Vergelijk de mogelijkheden',
      subtitle: 'Stap 3',
      description: 'Overzicht van alle mogelijkheden. Wat is voor u belangrijk?',
      image: {
        src: `${process.env.PUBLIC_URL}/img/vzk-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vergelijk-de-mogelijkheden',
      routeId: 'P6-018',
      nextRouteId: 'P6-019',
      type: 'explanation',
      title: 'Vergelijk de mogelijkheden',
      description: `
        <table class="table-layout-fixed">
          <thead>
            <tr>
              <th></th>
              <th>Wat betekent het?</th>
              <th>Wat kan ik verwachten?</th>
              <th>Wat kan er misgaan?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Niets doen</th>
              <td>Geen behandeling.</td>
              <td>De verzakking en de klachten kunnen hetzelfde blijven of erger worden in de loop van de tijd.</td>
              <td>Er kan niks misgaan.</td>
            </tr>
            <tr>
              <th>Leefstijl aanpassen</th>
              <td>Druk op de bekkenbodem minder maken door gezonder leven en adviezen opvolgen.</td>
              <td>Bij een kleine verzakking kunnen aanpassingen helpen.</td>
              <td>Er kan niks misgaan.</td>
            </tr>
            <tr>
              <th>Bekkenbodem-oefeningen</th>
              <td>Elke dag oefeningen doen om de spieren in uw bekkenbodem sterker te maken en te leren ontspannen.<br><br>Een bekken-fysiotherapeut kan helpen. </td>
              <td>Bij een kleine verzakking kunnen oefeningen helpen.</td>
              <td>Er kan niks misgaan.</td>
            </tr>
            <tr>
              <th>Een pessarium</th>
              <td>Een pessarium in de vagina om de verzakking terug te duwen.</td>
              <td>72 van de 100 vrouwen zijn na een jaar nog tevreden met het pressarium.</td>
              <td>Kleine kans op wondjes en drukplekken in uw vagina. </td>
            </tr>
            <tr>
              <th>Een operatie</th>
              <td>Operatie om de verzakking te behandelen.<br>1 tot 2 dagen in het ziekenhuis.<br>6 weken herstellen.</td>
              <td>92 van de 100 vrouwen zijn tevreden.<br>Bij ongeveer 25 van de 100 vrouwen komt de verzakking terug.</td>
              <td>
                Tijdens of snel na de operatie:
                <ul>
                  <li>Blaasontsteking</li>
                  <li>Bloeding</li>
                  <li>Wondontsteking</li>
                  <li>Bloedprop in de benen (trombose)</li>
                  <li>Schade aan blaas of darm</li>
                  <li>Moeite met uitplassen de dagen na de operatie.</li>
                </ul>
                <br>
                Langer na de operatie:
                <ul>
                  <li>Pijn bij het vrijen</li>
                  <li>Urineverlies</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-3/vergelijk-de-mogelijkheden-2',
      routeId: 'P6-019',
      nextRouteId: 'P6-020',
      type: 'explanation',
      title: 'Vergelijk de mogelijkheden',
      description: `
        <table class="table-layout-fixed">
          <thead>
            <tr>
              <th></th>
              <th>Voordelen</th>
              <th>Nadelen</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Niets doen</th>
              <td>U hoeft niets te doen. U hoeft nergens aan te denken.<br>U hoeft niet naar het ziekenhuis.<br>Er is geen kans dat er iets misgaat bij een behandeling.<br>U kunt altijd nog kiezen voor een behandeling. U bent dan niet ‘te laat’.</td>
              <td>Uw verzakking en klachten blijven.<br>U weet niet of uw verzakking en klachten hetzelfde zullen blijven of erger worden. </td>
            </tr>
            <tr>
              <th>Leefstijl aanpassen</th>
              <td>Er is een kans dat uw verzakking en klachten minder worden.<br>U kunt de adviezen zelf uitvoeren.<br>U hoeft niet naar het ziekenhuis.<br>Er kan niks misgaan.<br>Het is heel goed voor uw gezondheid.<br>U kunt altijd nog kiezen voor een andere behandeling. U bent dan niet ‘te laat’.</td>
              <td>Uw verzakking blijft.<br>Het kan moeilijk zijn om uw manier van leven aan te passen.<br>Als u stopt met de adviezen, kunnen uw klachten weer terugkomen.<br>Bij een ernstige verzakking helpt het niet genoeg om alleen uw leefstijl aan te passen.</td>
            </tr>
            <tr>
              <th>Bekkenbodem-oefeningen</th>
              <td>Er is een kans dat uw verzakking en klachten minder worden.<br>U hoeft niet naar het ziekenhuis.<br>Er kan niks misgaan.<br>U kunt de oefeningen zelf leren. U kunt ook hulp krijgen van een bekken-fysiotherapeut.<br>U kunt altijd nog kiezen voor een andere behandeling. U bent dan niet ‘te laat’.<br>Een bekken-fysiotherapeut kan u ook leefstijladviezen geven.<br>De oefeningen kunnen ook helpen bij urineverlies.</td>
              <td>Uw verzakking blijft.<br>Oefeningen kunnen soms lastig zijn om te leren.<br>Als het niet lukt om de oefeningen te leren, moet u naar de bekken-fysiotherapeut.<br>U moet de oefeningen elke dag doen. De oefeningen worden een onderdeel van uw leven.<br>Bij een ernstige verzakking helpt het niet genoeg om alleen bekkenbodem-oefeningen te doen.</td>
            </tr>
            <tr>
              <th>Een pessarium</th>
              <td>Er is een kans dat uw klachten minder worden.<br>Het werkt meteen na plaatsen.<br>U hoeft niet naar het ziekenhuis als uw huisarts het juiste pessarium voor u heeft.<br>Als u de juiste maat pessarium heeft en geen klachten, dan hoeft u niet meer naar een arts.<br>U kunt het pessarium zelf schoonmaken.<br>Bekkenbodem-oefeningen zijn beter uit te voeren als u ook een pessarium draagt.<br>Een pessarium kan ook helpen bij urineverlies.<br>Bijna iedereen kan een pessarium krijgen.</td>
              <td>Misschien is de maat van het pessarium niet in 1 keer goed. <br>Het pessarium kan eruit vallen. <br>Het pessarium moet minimaal elke 3 tot 6 maanden schoongemaakt worden. <br>U heeft waarschijnlijk meer afscheiding door het pessarium. <br>U heeft een kleine kans op wondjes en drukplekken in de vagina als u het pessarium lang achter elkaar draagt. <br>Heel soms kunt u door het pessarium moeilijker plassen of poepen. <br>Sommige vrouwen krijgen door een pessarium (meer) urineverlies. <br>Soms naar een gynaecoloog om een pessarium aan te meten.</td>
            </tr>
            <tr>
              <th>Een operatie</th>
              <td>De verzakking is weg.<br>Uw klachten zijn weg (als u een paar weken na de operatie weer beter bent).<br>U krijgt nog een controle na de operatie. Daarna hoeft u niet meer naar uw huisarts of gynaecoloog.</td>
              <td>U wordt 1 tot 2 dagen in het ziekenhuis opgenomen.<br>U heeft kans dat er iets misgaat bij de operatie.<br>U moet herstellen na de operatie. Misschien heeft u pijn na de operatie.<br>U mag 6 weken niet zwaar tillen, en geen oefeningen doen. Er mag niks in de vagina komen.<br>De operatie kan niet ongedaan gemaakt worden.<br>Er is een kans dat de verzakking terugkomt.</td>
            </tr>
          </tbody>
        </table>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-1',
      routeId: 'P6-020',
      nextRouteId: 'P6-021',
      type: 'question',
      title: 'Wat verwacht u van de behandeling?',
      questions: [
        {
          placeholder:
            'Bijvoorbeeld: minder minder zwaar gevoel in de vagina, geen urineverlies meer, beter kunnen zitten.',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-2',
      routeId: 'P6-021',
      nextRouteId: 'P6-022',
      type: 'question',
      title: 'Welke behandelingen heeft u al geprobeerd?',
      questions: [
        {
          type: 'multiple',
          answers: [
            { title: 'Leefstijl aanpassen' },
            { title: 'Bekkenbodem-oefeningen' },
            { title: 'Bekkenbodem-oefeningen met hulp van een bekken-fysiotherapeut' },
            { title: 'Een pessarium' },
            { title: 'Geen van de bovenstaande', deselectOthers: true },
          ],
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-3',
      routeId: 'P6-022',
      nextRouteId: 'P6-023',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik heb elke dag veel last van de verzakking.',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-4',
      routeId: 'P6-023',
      nextRouteId: 'P6-024',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik denk dat ik mijn leefstijl  kan veranderen.',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-5',
      routeId: 'P6-024',
      nextRouteId: 'P6-025',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik denk dat ik de bekkenbodem-oefeningen kan blijven doen.',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-6',
      routeId: 'P6-025',
      nextRouteId: 'P6-026',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik wil dat mijn klachten meteen weg zijn.',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-7',
      routeId: 'P6-026',
      nextRouteId: 'P6-027',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik durf het pessarium er zelf uit te halen.',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-8',
      routeId: 'P6-027',
      nextRouteId: 'P6-028',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: `Ik maak mij zorgen over de risico's en nadelen van een operatie.`,
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-9',
      routeId: 'P6-028',
      nextRouteId: 'P6-029',
      type: 'uniqueQuestion',
      subtitle: 'Maak een keuze',
      title: 'Wat wilt u?',
      layout: 'vertical',
      answers: [
        { title: 'Niets doen' },
        { title: 'Leefstijl aanpassen' },
        { title: 'Bekkenbodem-oefeningen' },
        { title: 'Een pessarium' },
        { title: 'Een operatie' },
        {
          title: 'Geen mening',
          nextRouteId: 'P6-031',
        },
      ],
    },
    {
      path: '/stap-3/vraag-10',
      routeId: 'P6-029',
      nextRouteId: 'P6-030',
      type: 'question',
      title: 'Waarom wilt u dit het liefst?',
      questions: [
        {
          placeholder: 'Licht uw keuze toe',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-3/vraag-11',
      routeId: 'P6-030',
      nextRouteId: 'P6-031',
      type: 'likertScale',
      title: 'Hoe zeker bent u van wat u wilt?',
      subtitle: 'Maak een keuze',
      answers: [
        { title: 'Heel onzeker' },
        { title: 'Onzeker' },
        { title: 'Weet ik niet' },
        { title: 'Zeker' },
        { title: 'Heel zeker' },
      ],
      button: 'Door naar uw antwoorden',
    },
    {
      path: '/print-overview',
      routeId: 'P6-031',
      nextRouteId: 'end',
      type: 'end',
    },
  ],
}

export default verzakking
